import React, { useState, useCallback } from 'react';
import { Button } from './ui/Button';
import { exportFile } from '../api';
import { useToast } from './Toast';

const ExportButtons = ({ totalLinks }) => {
  const [exporting, setExporting] = useState({ csv: false, xlsx: false });
  const toast = useToast();

  const handleExport = useCallback(async (format) => {
    if (!totalLinks) { toast('Нет данных для экспорта', 'warning'); return; }
    try {
      setExporting(p => ({ ...p, [format]: true }));
      const blob = await exportFile(format);
      const url = URL.createObjectURL(new Blob([blob], {
        type: format === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }));
      const a = document.createElement('a');
      a.href = url; a.download = `sound_analysis.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch (e) {
      toast(`Ошибка экспорта: ${e?.response?.data?.detail || e.message}`, 'error');
    } finally {
      setExporting(p => ({ ...p, [format]: false }));
    }
  }, [totalLinks, toast]);

  if (!totalLinks) return null;

  return (
    <div className="flex items-center gap-md">
      <Button
        variant="secondary"
        size="sm"
        icon="bi-filetype-csv"
        loading={exporting.csv}
        onClick={() => handleExport('csv')}
        title="Экспорт в CSV"
        aria-label="Экспорт в CSV"
      >
        <span className="hidden sm:inline">CSV</span>
      </Button>
      <Button
        variant="secondary"
        size="sm"
        icon="bi-file-earmark-excel"
        loading={exporting.xlsx}
        onClick={() => handleExport('xlsx')}
        title="Экспорт в Excel"
        aria-label="Экспорт в Excel"
      >
        <span className="hidden sm:inline">Excel</span>
      </Button>
    </div>
  );
};

export default ExportButtons;
